import { createAction } from 'redux-act';

export const ACTIVE_TAB = createAction('ACTIVE_TAB');

export const setActiveTab = ({ tab }) => {
  return async (dispatch) => {
    return dispatch(ACTIVE_TAB({ tab }));
  };
};
